module.exports = import("/print-ui/app/assets/remoteEntry.js");